let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("5QWBH")).then(() => parcelRequire('jR0A3'));